// cSpell: disable

import { LANG } from '@/store'
import type { IChipData } from './_header'
import { RESPONSE_CASE, TOAST_CASE } from './_header'

export enum CHIP_KEY {
  ID_01 = 'BANTADTHONG_RC01',
  ID_02 = 'BANTADTHONG_RC02',
  ID_03 = 'BANTADTHONG_RC03',
  ID_04 = 'BANTADTHONG_RC04',
  ID_05 = 'BANTADTHONG_RC05',
  ID_06 = 'BANTADTHONG_RC06',
  ID_07 = 'BANTADTHONG_RC07',
  ID_08 = 'BANTADTHONG_RC08',
  ID_09 = 'BANTADTHONG_RC09',
  ID_10 = 'BANTADTHONG_RC10',
}

export enum CHIP_ENCRYPTED_ID {
  ID_01 = 'aZ3bT1k',
  ID_02 = 'GmP7qW8',
  ID_03 = 'LxN5cZ2',
  ID_04 = 'K7rXp3Q',
  ID_05 = 'W9eJr2V',
  ID_06 = 'Tq4BdY1',
  ID_07 = 'Mv6LcX9',
  ID_08 = 'Hs83nVr',
  ID_09 = 'Dq2XpFb',
  ID_10 = 'Zp1Kr67',
}

export const _chips: Record<CHIP_KEY, IChipData> = {
  [CHIP_KEY.ID_01]: {
    _id: CHIP_KEY.ID_01,
    encryptedId: CHIP_ENCRYPTED_ID.ID_01,
    order: 1,
    title: 'Tang Jai Joom',
    description: {
      [LANG.TH]:
        'บริเวณตรงข้ามกับซอยจุฬา 14 ก่อนถึงแยกจรัสเมือง ร้านตั้งใจจุ่มที่ซึ่งไม่ได้เป็นแค่สายพานหม้อไฟ แต่เสิร์ฟความตั้งใจในทุกขั้นตอน',
      [LANG.EN]:
        'Opposite Soi Chula 14, just before Charas Muang Intersection — Tang Jai Joom, more than just a hotpot conveyor belt; it serves heartfelt care in every step.',
    },
    color: '#ff90f1',
    position: {
      lat: 13.7426605,
      lng: 100.5227883,
    },
  },
  [CHIP_KEY.ID_02]: {
    _id: CHIP_KEY.ID_02,
    encryptedId: CHIP_ENCRYPTED_ID.ID_02,
    order: 2,
    title: 'Nam Dao Huu',
    description: {
      [LANG.TH]:
        'บริเวณแยกจรัสเมือง หน้าร้าน Nam Dao Huu ร้านน้ำเต้าหู้สูตรโบราณเจ้าดังจากเยาวราช เสิร์ฟพร้อมท็อปปิ้งสุดจึ้ง ที่จะทำให้การกินน้ำเต้าหู้ไม่น่าเบื่ออีกต่อไป มาลองกันนะ!',
      [LANG.EN]:
        'At Charas Muang Intersection, right in front of Nam Dao Huu — the legendary traditional soy milk shop from Yaowarat! Served with wow-worthy toppings that’ll change the way you think about soy milk. Come give it a try!',
    },
    color: '#e933d0',
    position: {
      lat: 13.7422043,
      lng: 100.5226352,
    },
  },
  [CHIP_KEY.ID_03]: {
    _id: CHIP_KEY.ID_03,
    encryptedId: CHIP_ENCRYPTED_ID.ID_03,
    order: 3,
    title: 'Banthat Tong Roast Duck',
    description: {
      [LANG.TH]:
        'เลี้ยวเข้ามาใน ซอยจุฬา 14 ซิกเนเจอร์คือเป็ดย่างสูตรบุรีรัมย์ รวมถึงสารพัดตำ เสิร์ฟความแซ่บสุดอร่อย!!',
      [LANG.EN]:
        'Turn into Soi Chula 14 and discover our signature Buriram-style roast duck — plus a variety of spicy “tam” dishes.',
    },
    color: '#a521f6',
    position: {
      lat: 13.7430852,
      lng: 100.5233536,
    },
  },
  [CHIP_KEY.ID_04]: {
    _id: CHIP_KEY.ID_04,
    encryptedId: CHIP_ENCRYPTED_ID.ID_04,
    order: 4,
    title: 'KAOTOMTHEWET',
    description: {
      [LANG.TH]:
        'เรื่องราวกว่า 70 ปีแห่งความอร่อย ที่นี่ไม่ใช่แค่ร้านอาหาร แต่คือ ประวัติศาสตร์ความอร่อย รสชาติเกินราคา อร่อยแบบดั้งเดิม',
      [LANG.EN]:
        'Over 70 years of delicious history — this isn’t just a restaurant, it’s a legacy of flavor. Unbeatable taste at a great price with authentic recipes!',
    },
    color: '#0142ff',
    position: {
      lat: 13.7371287,
      lng: 100.5217238,
    },
  },
  [CHIP_KEY.ID_05]: {
    _id: CHIP_KEY.ID_05,
    encryptedId: CHIP_ENCRYPTED_ID.ID_05,
    order: 5,
    title: 'Cookkimao Banthat Thong',
    description: {
      [LANG.TH]:
        'บริเวณตรงข้ามซอยจุฬา 28 หน้าร้านกุ๊กขี้เมาของเชฟเป้ จากช่อง Youtube: COOKKIMAO ที่มีผู้ติดตามมากกว่า 500K พร้อมเสิร์ฟอาหารไทยรสชาติเข้มข้นถึงเครื่องแบบเต็มปากเต็มคำ!',
      [LANG.EN]:
        'Right across from Soi Chula 28, in front of Cookkimao — the bold Thai eatery by Chef Pae from the YouTube channel COOKKIMAO with over 500K subscribers!',
    },
    color: '#00aeff',
    position: {
      lat: 13.7387402,
      lng: 100.5220138,
    },
  },
  [CHIP_KEY.ID_06]: {
    _id: CHIP_KEY.ID_06,
    encryptedId: CHIP_ENCRYPTED_ID.ID_06,
    order: 6,
    title: 'Rattiya Jaew Hon Banthadthong',
    description: {
      [LANG.TH]: 'อาหารอีสานรสจัดจ้านถึงใจ บรรยากาศอบอุ่นแบบบ้านๆ ห้ามพลาด!',
      [LANG.EN]:
        'Dive into bold and flavorful Isaan dishes in a warm, homestyle atmosphere. A must-visit spot!',
    },
    color: '#0eff70',
    position: {
      lat: 13.7456834,
      lng: 100.5233477,
    },
  },
  [CHIP_KEY.ID_07]: {
    _id: CHIP_KEY.ID_07,
    encryptedId: CHIP_ENCRYPTED_ID.ID_07,
    order: 7,
    title: 'Stadium One (Charoen Phon Intersection)',
    description: {
      [LANG.TH]: 'สี่แยกเจริญผล หรือเป็นที่รู้จักในนาม จุดเริ่มต้นของถนนบรรทัดทอง',
      [LANG.EN]:
        'Charoen Phon Intersection, also known as the starting point of Banthat Thong Road.',
    },
    color: '#ffd202',
    position: {
      lat: 13.747089,
      lng: 100.523983,
    },
  },
  [CHIP_KEY.ID_08]: {
    _id: CHIP_KEY.ID_08,
    encryptedId: CHIP_ENCRYPTED_ID.ID_08,
    order: 8,
    title: 'Buntudthong Fishball',
    description: {
      [LANG.TH]:
        'ลูกชิ้นปลาเนื้อแน่น เด้งหนึบ สูตรต้นตำรับ พร้อมน้ำซุปหอมกลมกล่อม ยำเส้นแก้วแซ่บจี๊ดถึงใจ!',
      [LANG.EN]:
        'Firm, springy fishballs made from an original recipe, served in a fragrant, flavorful broth — plus a glass noodle salad that’s bold, spicy, and bursting with zing!',
    },
    color: '#ff8200',
    position: {
      lat: 13.7463634,
      lng: 100.5236893,
    },
  },
  [CHIP_KEY.ID_09]: {
    _id: CHIP_KEY.ID_09,
    encryptedId: CHIP_ENCRYPTED_ID.ID_09,
    order: 9,
    title: 'Trok Sung Stewed Pork Leg',
    description: {
      [LANG.TH]:
        'ร้านขาหมูตรอกซุงที่มีชื่อเสียงมาอย่างยาวนาน ได้เครื่องหมายเชลล์ชวนชิม การันตีความอร่อยแบบดั้งเดิมตั้งแต่ปี พ.ศ. 2528',
      [LANG.EN]:
        'The legendary Trok Sung Stewed Pork Leg shop has been serving up delicious, traditional flavors since 1985 — proudly certified with the Shell Chuan Chim mark for excellence!',
    },
    color: '#ea3222',
    position: {
      lat: 13.7428931,
      lng: 100.5236012,
    },
  },
  [CHIP_KEY.ID_10]: {
    _id: CHIP_KEY.ID_10,
    encryptedId: CHIP_ENCRYPTED_ID.ID_10,
    order: 10,
    title: 'Lobster City',
    description: {
      [LANG.TH]:
        'บริเวณ Lobster City แลนด์มาร์คตรงข้ามสวนจุฬา 100 ปี โดดเด่นทั้งตึก แสงสีและความสวยงามโดยรอบ เสิร์ฟอาหารซีฟู้ดทอดร้อนๆ กรอบนอกนุ่มใน สดใหม่ทุกวัน พร้อมขนกองทัพความอร่อยอีกเพียบ',
      [LANG.EN]:
        'Lobster City, the standout landmark across from Chula 100 Years Park, is known for its eye-catching building, vibrant lights, and stunning surroundings. It serves hot, crispy, and tender seafood, freshly made daily.',
    },
    color: '#FF1493',
    position: {
      lat: 13.7400351,
      lng: 100.5222751,
    },
  },
}

export const mapConfig = {
  mapId: 'b7a4db1da20e6902611021c6',
  // mapId: '63277408d1a44e57', // Production
  center: {
    lat: 13.742436,
    lng: 100.522789,
  },
  zoom: 17.5,
}

export const _responseCase = {
  [RESPONSE_CASE.NO_SESSION]: {
    message: 'Unauthorized',
  },
  [RESPONSE_CASE.NO_USER]: {
    message: 'No username that requested',
  },
  [RESPONSE_CASE.ALREADY]: {
    message: 'The item is already added',
  },
  [RESPONSE_CASE.ERROR]: {
    message: 'Error while updating items',
  },
}

export const _toastCase = {
  [TOAST_CASE.COLLECT_SUCCESS]: {
    message: 'Collect success',
  },
  [TOAST_CASE.COLLECT_FAILED]: {
    message: 'Error occurred during add to database',
  },
  [TOAST_CASE.ALREADY_COLLECTED]: {
    message: 'You have already collected this chip',
  },
  [TOAST_CASE.SCAN_INVALID_QR]: {
    message: 'Invalid QR code, please try again',
  },
  [TOAST_CASE.SCAN_INVALID_ID]: {
    message: 'ID not found, please check the QR',
  },
  [TOAST_CASE.SCAN_ERROR]: {
    message: 'Error occurred during scan QR',
  },
  [TOAST_CASE.SCAN_TOO_FAR]: {
    message: 'You are too far from the chip',
  },
  [TOAST_CASE.REDEEM_NOT_6_DIGITS]: {
    message: 'Please enter 6 digits',
  },
  [TOAST_CASE.REDEEM_INVALID_PASSWORD]: {
    message: 'Invalid redeem password',
  },
  [TOAST_CASE.REDEEM_FAIL]: {
    message: 'Wrong password',
  },
  [TOAST_CASE.REDEEM_SUCCESS]: {
    message: 'Redeem success',
  },
  [TOAST_CASE.REDEEM_ERROR]: {
    message: 'Error occurred during redeem',
  },
}
